var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCtv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#00853E;}\n\t.st2{fill:#FFFFFF;}\n\t.bg-fill{fill:#FFFFFF;stroke:#767777;stroke-width:2;stroke-miterlimit:10;}\n\t.icon-outline{fill:#767777;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lime_Green_94CA5F"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.9,0H10.1C4.6,0,0,4.5,0,10V60c0,5.5,4.5,10,10.1,10h49.8c5.5,0,10-4.5,10-10V10C70,4.5,65.4,0,59.9,0z  M68,60c0,4.4-3.6,8-8,8H10.1C5.7,68,2,64.4,2,60V10C2,5.6,5.7,2,10.1,2h49.8c4.4,0,8,3.6,8,8.1V60z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Main_Green_00853E"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg-fill",
    d: "M59.9,2H10.1C5.7,2,2,5.6,2,10V60c0,4.4,3.6,8,8.1,8h49.8c4.4,0,8-3.6,8-8V10C68,5.6,64.3,2,59.9,2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "White"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-outline",
    d: "M59.3,14.2H10.7c-1.3,0-2.4,1.1-2.4,2.4l0,0v31.3c0,1.3,1.1,2.4,2.4,2.4h22.6v3.9h-2.1c-0.4,0-0.8,0.3-0.8,0.8 s0.3,0.8,0.8,0.8h9.2c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.1v-3.9h21.1c1.3,0,2.4-1.1,2.4-2.4V16.6 C61.7,15.3,60.6,14.2,59.3,14.2L59.3,14.2z M36.7,54.2h-1.9v-3.9h1.9L36.7,54.2z M60.2,47.9c0,0.5-0.4,0.9-0.9,0.9H10.7 c-0.5,0-0.9-0.4-0.9-0.9V16.6c0-0.5,0.4-0.9,0.9-0.9h0h48.6c0.5,0,0.9,0.4,0.9,0.9V47.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "icon-outline",
    cx: 35,
    cy: 37.7,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-outline",
    d: "M40.1,34.7L40.1,34.7c-2.4-3-6.7-3.4-9.7-1.1c-0.2,0.2-0.4,0.3-0.5,0.5l0,0c-0.2,0.2-0.2,0.4-0.2,0.6 c0,0.5,0.4,0.9,0.9,0.9c0.2,0,0.5-0.1,0.6-0.3c2.1-2,5.3-1.9,7.3,0.1c0.1,0.1,0.3,0.3,0.4,0.5l0,0c0.3,0.3,0.9,0.3,1.2,0 c0.2-0.2,0.2-0.4,0.2-0.6C40.3,35,40.2,34.8,40.1,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-outline",
    d: "M42.3,32L42.3,32c-3.6-4.2-9.9-4.7-14.1-1c-0.2,0.1-0.3,0.3-0.5,0.4c-0.2,0.2-0.3,0.4-0.3,0.7 c0,0.5,0.4,0.9,0.9,0.9c0.2,0,0.5-0.1,0.7-0.3c3.3-3.2,8.5-3.1,11.7,0.1c0.2,0.2,0.3,0.3,0.5,0.5l0,0c0.2,0.2,0.4,0.3,0.6,0.3 c0.5,0,0.9-0.4,0.9-0.9c0,0,0,0,0,0C42.6,32.4,42.5,32.2,42.3,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-outline",
    d: "M44.5,29.4L44.5,29.4c-4.8-5.4-13.2-5.9-18.6-1.1c-0.2,0.2-0.3,0.3-0.5,0.5l0,0c-0.2,0.2-0.3,0.4-0.3,0.6 c0,0.5,0.4,0.9,0.9,0.9c0.2,0,0.4-0.1,0.6-0.2l0,0c4.5-4.5,11.7-4.4,16.2,0.1c0.2,0.2,0.3,0.3,0.5,0.5l0,0c0.2,0.2,0.4,0.3,0.6,0.3 c0.5,0,0.9-0.4,0.9-0.9C44.8,29.8,44.7,29.6,44.5,29.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtv);
export default __webpack_public_path__ + "static/media/ctv.5380ac7ed7e063d8e3b3ceaeb211d2d5.svg";
export { ForwardRef as ReactComponent };